// import { IGetConnectedMails, IGetMessagesParams } from 'src/services/mail'
// import { InternalLabels, ConfigStatesMail, IMessageModified } from './state'
import { createPhaseActions, phaseAction } from 'src/helpers/redux'
import type { IListItem } from 'src/store/modules/storage/objects/state'
import type { TTransferMode } from './state'

export const PREFIX = 'twilioNew'
export const PREFIX_SAGE = `${PREFIX}/saga`

/** Fields of a storage object needed to show who is called; a full `IListItem` fits too */
export type TConnectObject = Pick<
  IListItem,
  'uniqId' | 'objectSchemeIdentifier' | 'primary' | 'secondary' | 'icon'
>

export interface IConnectPayload {
  /** Cusman account id the call is made from (sent as `CusmanAccountId`) */
  userId?: string
  /** Number to call (sent as `To`) */
  toWhom: string
  /** Storage object of the number, if already known: skips its lookup by number */
  object?: TConnectObject
}

/** Call history of one storage object. Sent as `subscriberStorageUniqId` */
export interface IGetSubscriberCallHistoryPayload {
  subscriberStorageUniqId: string
}

export const actions = createPhaseActions(PREFIX_SAGE, {
  initialize: phaseAction<void>(),
  register: phaseAction<void>(),
  connect: phaseAction<IConnectPayload>(),
  accept: phaseAction<void>(),
  reject: phaseAction<void>(),
  disconnect: phaseAction<void>(),
  toggleMute: phaseAction<void>(),
  /** DTMF tones for the active call, e.g. "1", "#" */
  sendDigits: phaseAction<string>(),
  /** Puts the current backend call on hold */
  holdCurrentCall: phaseAction<void>(),
  /** Takes the current backend call off hold */
  unholdCurrentCall: phaseAction<void>(),
  /** Adds a user to the current backend call */
  addCallParticipant: phaseAction<number>(),
  /** Transfers the current call to a workspace user */
  transferCurrentCall: phaseAction<{ userId: number; mode: TTransferMode }>(),
  /** Completes a warm transfer that is in `consulting` */
  completeCurrentTransfer: phaseAction<void>(),
  /** Cancels a ringing or consulting transfer */
  cancelCurrentTransfer: phaseAction<void>(),
  /** Loads the call history of a storage object. Skips the request when that id is already saved */
  getSubscriberCallHistory: phaseAction<IGetSubscriberCallHistoryPayload>(),
})
export type Actions = typeof actions
